import axios from "axios";

export async function login(email: string, password: string): Promise<string> {
  try {
    const apiKey = localStorage.getItem("apiKey");
    const data = {
      email: email,
      password: password,
      returnSecureToken: true,
    };

    const response = await axios(
      `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword`,
      {
        method: "POST",
        params: {
          key: apiKey,
        },
        data: data,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const token = response.data["idToken"];
    localStorage.setItem("token", token);
    return token;
  } catch (error) {
    throw new Error(`${error}`);
  }
}
